import { Component } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';

@Component({
    selector: 'wci-steps-to-success',
    imports: [ButtonComponent],
    templateUrl: './steps-to-success.component.html',
    styles: ``,
})
export class StepsToSuccessComponent {}
